import React, { useState, useEffect } from "react";
import { IoMdAdd } from "react-icons/io";
import UserListTable from "./BlockedUsersList/BlockedUsersList";
import { getApiCaller } from "../../../../Libs/apiCaller";

export default function BlockedUsers() {
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [blockedUsers, setBlockedUsers] = useState([]);

  const openAddUserModal = () => {
    setIsAddUserModalOpen(true);
  };

  const closeAddUserModal = () => {
    setIsAddUserModalOpen(false);
  };

  useEffect(() => {
    setIsLoading(true);
    getBlockedUsers();
  }, []);

  const getBlockedUsers = async (page = 1, srch = search) => {
    const response = await getApiCaller(
      `users/blocked?page=${page}&limit=10&search=${srch}`
    );
    if (response.status === 200) {
      window.scrollTo(0, 0);
      setSearch(srch);
      setCurrentPage(response.data.currentPage);
      setBlockedUsers(response.data.users);
      setTotalUsers(response.data.totalUsers);
      setTotalPages(response.data.totalPages);
    }
    setIsLoading(false);
  };

  return (
    <section className="p-2">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-black">Blocked Users </h1>
      </div>

      <UserListTable
        setBlockedUsers={setBlockedUsers}
        getBlockedUsers={getBlockedUsers}
        blockedUsers={blockedUsers}
        openAddUserModal={openAddUserModal}
        isAddUserModalOpen={isAddUserModalOpen}
        closeAddUserModal={closeAddUserModal}
        currentPage={currentPage}
        totalPages={totalPages}
        totalUsers={totalUsers}
        search={search}
        setSearch={setSearch}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </section>
  );
}
